<template>
    <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M15.0024 11.0695L5.43696 1.5587L17.6072 8.48662L15.0024 11.0695ZM2.94051 1C2.37707 1.29224 2 1.82516 2 2.51709V21.4829C2 22.1748 2.37707 22.7078 2.94051 23L14.0619 11.9979L2.94051 1ZM21.3692 10.6956L18.8164 9.23012L15.9689 12.0021L18.8164 14.7742L21.4212 13.3087C22.2014 12.6941 22.2014 11.3102 21.3692 10.6956ZM5.43696 22.4456L17.6072 15.5177L15.0024 12.9348L5.43696 22.4456Z"
            fill="currentColor"
        />
    </svg>
</template>
